<!-- eslint-disable max-len -->
<template>
  <div id="maintenanceModeSetting">
    <div class="maintenance-container">
      <div class="d-flex">
        <div class="title heading-3">Maintenance Period</div>
        <div
          class="btn-add text-information"
          @click="openAdd">+ Add</div>
        <div class="search-data">
          <i class="fa fa-search" />
          <input
            v-model="search"
            type="text"
            placeholder="Search..."
            @keypress.13.prevent="handleSearch"
          >
        </div>
      </div>
      <div
        v-if="!loadingFirst && maintenanceList && maintenanceList.length > 0"
        class="maintenance-overflow-list">
        <div
          v-for="(item, index) in maintenanceList"
          :key="index"
          class="maintenance-list">
          <div
            v-if="getStatus(item.status)"
            :class="`block-status heading-5 ${item.status ? item.status.toLowerCase() : ''}`">
            {{ item.status }}
          </div>
          <div
            v-else
            :class="'block-status heading-5 unknown'">
            unknown
          </div>
          <img
            v-if="item.level === 'application' || item.level === 'page'"
            :src="require(`@/assets/icon/level-${item.level}.svg`)"
            class="m__l--10 m__t--1"
            width="15"
            height="15">
          <img
            v-else
            :src="require('@/assets/icon/level-application.svg')"
            class="m__l--10 m__t--1"
            width="15"
            height="15">
          <div class="title-list ellipsis heading-5 m__l--10">{{ item.title || '-' }}</div>
          <div class="date-list text-information">
            {{ item.start_period ? $moment(new Date(item.start_period)).format('DD MMMM YYYY HH:mm:ss') : '' }} -
            {{ item.end_period ? $moment(new Date(item.end_period)).format('DD MMMM YYYY HH:mm:ss') : '' }}
          </div>
          <div class="config-list">
            <img
              :src="require('@/assets/automation/config.svg')"
              class="cursor-pointer m__l--10"
              width="15"
              height="15"
              @click="openDetail(item, index)">
          </div>
        </div>
      </div>
      <div
        v-if="!loadingFirst && maintenanceList && maintenanceList.length === 0"
        class="maintenance-no-data">
        No Data
      </div>
      <div
        v-if="loadingFirst"
        class="m__t--10">
        <div
          v-for="i in 5"
          :key="i"
          class="skeleton"
        />
      </div>
      <div
        v-if="!loadingFirst && (maintenanceList && maintenanceList.length > 0) || (maintenanceList && pageData > 1)"
        class="custom-pagination">
        <div
          class="btn-previous"
          @click="previousPage"><i class="fa fa-chevron-left"/></div>
        <div
          class="btn-forward"
          @click="forwardPage"><i class="fa fa-chevron-right"/></div>
      </div>
    </div>

    <!-- Block Properties ---------------------------------------------------------------------- -->
    <div
      :class="{'show-container-properties-automation' : showProperties, 'hide-container-properties-automation' : !showProperties}"
      class="container-properties-automation">
      <div class="d-flex align-items-start justify-content-between">
        <div class="label-log-detail">
          Properties
          <span>Maintenance Mode</span>
        </div>
        <div
          class="close-properties-automation"
          @click="hideProperties">
          <img
            :src="require('@/assets/icon/icon-close-properties.svg')"
            width="25">
        </div>
      </div>

      <div class="privilege-data-manager-access">
        <div class="heading-4">General</div>
        <b-form-group :class="{'error-input' : $v.dataMaintenance.title.$error}">
          <label> Title </label>
          <j-input
            v-model="$v.dataMaintenance.title.$model"
            :error-required="false"
            :disabled="isDisabled"
            placeholder="Input Title"/>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.dataMaintenance.start_period.$error}">
              <label> Start Period </label>
              <j-date-time
                :type="'datetime'"
                :data="dataMaintenance.start_period"
                :error-required="false"
                :min-datetime="getDateToday()"
                :max-datetime="dataMaintenance.end_period ? getDateEndPeriode() : null"
                :disabled="isDisabled"
                placeholder="Enter Start Period"
                format="MMM dd, yyyy, HH:mm"
                @getTimestamp="setValueStartPeriode"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.dataMaintenance.end_period.$error}">
              <label> End Period </label>
              <j-date-time
                :type="'datetime'"
                :data="dataMaintenance.end_period"
                :error-required="false"
                :min-datetime="dataMaintenance.start_period ? getDateStartPeriode() : getDateToday()"
                :disabled="isDisabled"
                placeholder="Enter End Period"
                format="MMM dd, yyyy, HH:mm"
                @getTimestamp="setValueEndPeriode"/>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div
        :class="{'error-input' : $v.dataMaintenance.level.$error}"
        class="privilege-data-manager-access">
        <div class="heading-4">Level</div>
        <div class="text-information">Level of maintenance for this period</div>

        <div class="d-flex m__t--10">
          <div
            :class="{ 'active': dataMaintenance.level === 'application' }"
            class="level-maintenance"
            @click="changeLevel('application')" >
            Application
          </div>
          <div
            :class="{ 'active': dataMaintenance.level === 'page' }"
            class="level-maintenance"
            @click="changeLevel('page')" >
            Page
          </div>
        </div>

        <div
          v-if="dataMaintenance.level === 'page' && listPages && listPages.length > 0"
          class="maintenance-pages-container">
          <div
            v-for="valParent in isParent"
            v-show="valParent.type === 'visible' || getSubPageByParent(valParent.id).length > 0"
            :key="valParent.id"
            class="list-pages">
            <b-row class="pr-2">
              <b-col
                cols="10"
                class="information">
                <img
                  :src="valParent.icon_grey"
                  height="16"
                  width="16">
                <div class="heading-4 m__l--10">{{ valParent.name.toUpperCase() }}</div>
              </b-col>
              <b-col
                v-if="valParent.type === 'visible'"
                cols="2">
                <j-toggle
                  v-model="valParent.active_mode"
                  :disabled="isDisabled"
                  class="m__l--5"/>
              </b-col>
            </b-row>

            <div
              v-for="valChild in getSubPageByParent(valParent.id)"
              :key="valChild.id"
              class="list-page-child">
              <b-row class="pr-2">
                <b-col
                  cols="10"
                  class="information">
                  <img
                    :src="valChild.icon_grey"
                    height="16"
                    width="16">
                  <div class="heading-4 m__l--10">{{ valChild.name.toUpperCase() }}</div>
                </b-col>
                <b-col cols="2">
                  <j-toggle
                    v-model="valChild.active_mode"
                    :disabled="isDisabled"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>

      <hr>
      <div class="heading-3">Configuration</div>

      <div class="privilege-data-manager-access m__t--10">
        <div class="d-flex">
          <div class="custom-message">
            <div class="heading-4">Custom Message</div>
            <div class="text-information">Enter your custom message in the text box to display a popup warning when a user clicks on this application or this page</div>
          </div>
          <div class="privilege-data-manager-access-toggle">
            <j-toggle
              v-model="dataMaintenance.is_use_custom_message"
              :disabled="isDisabled"
              class="m__t--12"/>
          </div>
        </div>

        <b-form-group
          v-show="dataMaintenance.is_use_custom_message"
          :class="{'error-input' : $v.dataMaintenance.custom_message.$error}">
          <label> Title </label>
          <j-textarea
            v-model="$v.dataMaintenance.custom_message.$model"
            :error-required="false"
            :max-length="300"
            :disabled="isDisabled"
            placeholder="Type custom message"/>
        </b-form-group>
      </div>

      <div
        :class="{'error-input' : dataMaintenance.is_use_user_exception && dataUserOrganigram.length === 0 && $v.dataMaintenance.user_organigram_exception.$error}"
        class="privilege-data-manager-access m__t--10">
        <div class="d-flex">
          <div class="custom-message">
            <div class="heading-4">Position Exception</div>
            <div class="text-information">specify which position should not be placed in maintenance mode</div>
          </div>
          <div class="privilege-data-manager-access-toggle">
            <j-toggle
              v-model="dataMaintenance.is_use_user_exception"
              :disabled="isDisabled"
              class="m__t--12"/>
          </div>
        </div>

        <div v-show="dataMaintenance.is_use_user_exception">
          <div
            v-if="isShowModalOrganigram"
            class="modal-organigram">
            <div class="heading-2">Add Position</div>
            <b-form-group :class="{'error-input' : $v.userOrganigram.$error}">
              <label>Position</label>
              <j-single-select
                v-model="$v.userOrganigram.$model"
                :custom="true"
                :is-async="true"
                :cache-options="false"
                :load-options="loadUserOptions"
                :placeholder="'Select Position'"
                value-format="object"
                label="name">
                <template
                  slot-scope="node"
                  slot="node-custom"
                  class="d-flex">
                  <div class="d-flex">
                    <div class="m__r--7">
                      <b-img
                        v-if="node.node.raw.user && node.node.raw.user.profile && node.node.raw.user.profile.photo_url"
                        :src="node.node.raw.user.profile.photo_url"
                        rounded="circle"
                        alt="img"
                        class="m-1 round-bordered-img
                        img-circle staff-img image-popup-link b-page-theme td"/>
                      <b-img
                        v-else
                        :src="require('@/assets/logo/user1.png')"
                        rounded="circle"
                        alt="img"
                        class="m-1 round-bordered-img
                        img-circle staff-img image-popup-link b-page-theme td"/>
                    </div>
                    <div
                      v-if="node.node.raw.user && node.node.raw.user.profile"
                      class="m__t--5">
                      <div class="privilege-user-info-fullname">{{ node.node.raw.id }} - {{ node.node.raw.name }}</div>
                      <div class="privilege-user-info-email">{{ node.node.raw.user.profile.first_name }} {{ node.node.raw.user.profile.last_name }}</div>
                      <div class="privilege-user-info-email">{{ node.node.raw.user.profile.email }}</div>
                    </div>
                    <div
                      v-else
                      class="m__t--5">
                      <div class="privilege-user-info-fullname">{{ node.node.raw.id }} - {{ node.node.raw.name }}</div>
                      <div class="privilege-user-info-email">No User</div>
                      <div class="privilege-user-info-email">-</div>
                    </div>
                  </div>
                </template>
              </j-single-select>
            </b-form-group>

            <div class="d-flex justify-content-end mt-2">
              <button
                class="button-border mr-2"
                @click="closeModalOrganigram"
              >
                Close
              </button>
              <button
                class="button-blue"
                @click="submitOrganigram"
              >
                Add
              </button>
            </div>
          </div>

          <div
            v-for="(item, index) in dataUserOrganigram"
            :key="index"
            class="m__t--20">
            <div class="d-flex">
              <div class="m__r--7 p__t--3">
                <b-img
                  v-if="item.user && item.user.profile && item.user.profile.photo_url"
                  :src="item.user.profile.photo_url"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                  img-circle staff-img image-popup-link b-page-theme td"/>
                <b-img
                  v-else
                  :src="require('@/assets/logo/user1.png')"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                  img-circle staff-img image-popup-link b-page-theme td"/>
              </div>
              <div
                v-if="item.user && item.user.profile"
                class="info-organigram m__t--5">
                <div class="privilege-user-info-fullname">{{ item.id }} - {{ item.name }}</div>
                <div class="privilege-user-info-email">{{ item.user.profile.first_name }} {{ item.user.profile.last_name }}</div>
                <div class="privilege-user-info-email">{{ item.user.profile.email }}</div>
              </div>
              <div
                v-else
                class="info-organigram m__t--5">
                <div class="privilege-user-info-fullname">{{ item.id }} - {{ item.name }}</div>
                <div class="privilege-user-info-email">No User</div>
                <div class="privilege-user-info-email">-</div>
              </div>
              <div
                v-if="!isDisabled"
                class="btn-remove-org">
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="removeOrganigram(index)" />
              </div>
            </div>
          </div>
          <div
            v-if="!isDisabled"
            class="text-information cursor-pointer add-suer m__t--10"
            @click="showModalOrganigram">+ Add Position</div>
        </div>
      </div>

      <div
        v-if="dataEdit && !isDisabled"
        class="privilege-data-manager-access m__t--10">
        <div class="heading-4">Force Terminate Maintenance</div>
        <div class="text-information">The maintenance process ends early</div>
        <div
          class="btn-terminate"
          @click="terminateMaintenanceMode">Terminate</div>
      </div>

      <div
        :class="{'show-privilege-data-manager-access-button' : showProperties, 'hide-privilege-data-manager-access-button' : !showProperties}"
        class="privilege-data-manager-access-button">
        <button
          :class="`button-border ${ isDisabled ? 'close-prop' : 'close-prop-2'}`"
          @click="hideProperties">
          Close
        </button>
        <button
          v-if="!isDisabled"
          class="button-border submit-prop"
          @click="submitMaintenanceMode">
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console, camelcase */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

import jDateTime from '@/components/inputs/jDateTime';
import jApiUser from '@/services/jApiUser';

export default {
  components: {
    jDateTime,
  },

  data() {
    return {
      search: '',
      searchData: '',
      pageData: 1,
      limitData: 20,
      maintenanceList: [],
      listPages: [],
      showProperties: false,
      loadingFirst: true,
      isShowModalOrganigram: false,
      userOrganigram: null,
      dataUserOrganigram: [],
      dataEdit: null,
      dataIndex: null,
      dataResponse: null,

      dataMaintenance: {
        title: null,
        start_period: null,
        end_period: null,
        level: '',
        is_use_custom_message: false,
        custom_message: '',
        is_use_user_exception: false,
        user_organigram_exception: null,
        application_id: Number(this.$route.params.id),
        pages_id: null,
      },
    };
  },

  computed: {
    isParent() {
      return this.listPages.filter(valParent => valParent.parent_id === 0)
        .sort((a, b) => a.order - b.order);
    },

    isDisabled() {
      return this.dataEdit && (this.dataEdit.status === 'TERMINATED' || this.dataEdit.status === 'EXPIRED');
    },
  },

  watch: {
    search(val) {
      if (!val) {
        this.pageData = 1;
        this.searchData = '';
        this.getMaintenanceModeList(Number(this.$route.params.id), { title: '' }, this.pageData, this.limitData);
      }
    },
  },

  created() {
    this.getApplicationPages();
    this.getMaintenanceModeList(Number(this.$route.params.id), { title: '' }, this.pageData, this.limitData);
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreMaintenanceMode', ['actionGetMaintenanceModeList', 'actionCreateMaintenanceMode', 'actionUpdateMaintenanceMode', 'actionTerminateMaintenanceMode']),
    ...mapActions('jStoreSetting', ['actionGetPagesList']),

    getMaintenanceModeList(application_id, filter, page, limit) {
      const param = { application_id, filter, page, limit };
      this.loadingFirst = true;

      this.actionGetMaintenanceModeList(param).then((res) => {
        this.maintenanceList = res.data;
        if (this.dataResponse) {
          const findIndex = this.maintenanceList.findIndex(f => f.id === this.dataResponse.id);
          if (findIndex !== -1) this.maintenanceList[findIndex] = this.dataResponse;
          else this.maintenanceList.push(this.dataResponse);
          this.maintenanceList.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
          this.dataResponse = null;
        }
        this.loadingFirst = false;
      });
    },

    getApplicationPages() {
      const applicationId = this.$route.params.id;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetPagesList({ applicationId, param }).then((res) => {
        if (!res.error) {
          const data = res.data;
          data.map((page, index) => {
            data[index].active_mode = false;
            return page;
          });
          this.listPages = data;
        }
      });
    },

    getStatus(data) {
      const status = data ? data.toLowerCase() : '';
      const dataStatus = ['upcoming', 'active', 'terminated', 'expired'];
      return dataStatus.includes(status);
    },

    openAdd() {
      if (this.showProperties) {
        this.hideProperties();
        setTimeout(() => { this.showProperties = true; }, 500);
      } else {
        this.showProperties = true;
      }
    },

    openDetail(data, index) {
      this.dataEdit = data;
      this.dataIndex = index;
      this.dataMaintenance = {
        id: data.id || null,
        title: data.title || null,
        start_period: data.start_period || null,
        end_period: data.end_period || null,
        level: data.level || '',
        is_use_custom_message: data.is_use_custom_message || false,
        custom_message: data.custom_message || '',
        is_use_user_exception: data.is_use_user_exception || false,
        user_organigram_exception: data.user_organigram_exception && data.user_organigram_exception.length > 0 ?
          data.user_organigram_exception.map(el => (el.organigram_id)) : null,
        application_id: data.application_id || Number(this.$route.params.id),
        pages_id: data.pages_id || null,
      };
      if (data.user_organigram_exception && data.user_organigram_exception.length > 0) {
        this.dataUserOrganigram = data.user_organigram_exception.map(val => ({
          id: val.organigram_id,
          name: val.organigram_name,
          user: {
            profile: {
              first_name: val.employee_name,
              last_name: '',
              email: val.email,
              photo_url: val.photo_url,
            },
          },
        }));
      }
      if (data.pages_id && data.pages_id.length > 0) {
        data.pages_id.map((page) => {
          const indexPage = this.listPages.findIndex(f => f.id === page);
          if (indexPage !== -1) this.listPages[indexPage].active_mode = true;
          return page;
        });
      }
      this.openAdd();
    },

    hideProperties() {
      this.showProperties = false;
      this.dataUserOrganigram = [];
      this.dataEdit = null;
      this.dataIndex = null;

      this.dataMaintenance = {
        title: null,
        start_period: null,
        end_period: null,
        level: '',
        is_use_custom_message: false,
        custom_message: '',
        is_use_user_exception: false,
        user_organigram_exception: null,
        application_id: Number(this.$route.params.id),
        pages_id: null,
      };

      this.listPages.map((page, index) => {
        this.listPages[index].active_mode = false;
        return page;
      });
      setTimeout(() => { this.$v.dataMaintenance.$reset(); }, 100);
    },

    mappingPages() {
      this.dataMaintenance.pages_id = this.listPages.filter(f => f.active_mode).map(el => (el.id));
    },

    mappingPayloadUpdate() {
      const payload = Object.assign({}, this.dataMaintenance);
      if (this.dataEdit.title === this.dataMaintenance.title) delete payload.title;
      if (this.dataEdit.start_period === this.dataMaintenance.start_period) delete payload.start_period;
      if (this.dataEdit.end_period === this.dataMaintenance.end_period) delete payload.end_period;
      if (this.dataEdit.level === this.dataMaintenance.level) delete payload.level;
      if (this.dataEdit.is_use_custom_message === this.dataMaintenance.is_use_custom_message) delete payload.is_use_custom_message;
      if (this.dataEdit.custom_message === this.dataMaintenance.custom_message) delete payload.custom_message;
      if (this.dataEdit.is_use_user_exception === this.dataMaintenance.is_use_user_exception) delete payload.is_use_user_exception;
      if (JSON.stringify(this.dataEdit.user_organigram_exception && this.dataEdit.user_organigram_exception.length > 0 ? this.dataEdit.user_organigram_exception.map(el => (el.organigram_id)) : null) ===
      JSON.stringify(this.dataMaintenance.user_organigram_exception)) delete payload.user_organigram_exception;
      if (this.dataEdit.application_id === this.dataMaintenance.application_id) delete payload.application_id;
      if (JSON.stringify(this.dataEdit.pages_id) === JSON.stringify(this.dataMaintenance.pages_id)) delete payload.pages_id;
      return payload;
    },

    submitMaintenanceMode() {
      this.$v.dataMaintenance.$touch();
      if (!this.$v.dataMaintenance.$error) {
        if (this.dataMaintenance.level === 'page') this.mappingPages();
        if ((this.dataMaintenance.user_organigram_exception &&
        this.dataMaintenance.user_organigram_exception.length === 0) ||
        !this.dataMaintenance.is_use_user_exception) this.dataMaintenance.user_organigram_exception = null;
        const payload = this.dataEdit ? this.mappingPayloadUpdate() : this.dataMaintenance;
        const action = this.dataEdit ? 'actionUpdateMaintenanceMode' : 'actionCreateMaintenanceMode';
        this[action](payload).then((res) => {
          if (!res.error) {
            this.dataResponse = res.data;
            this.getMaintenanceModeList(Number(this.$route.params.id), { title: this.searchData }, this.pageData, this.limitData);
            this.hideProperties();
          }
        });
      }
    },

    terminateMaintenanceMode() {
      this.$swal({
        title: 'Terminate Data',
        type: 'warning',
        html: 'Are you sure to terminate this data?',
        showCancelButton: true,
        confirmButtonText: 'Terminate',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = { id: this.dataEdit.id };
          this.actionTerminateMaintenanceMode(param).then((res) => {
            if (!res.error) {
              this.dataResponse = res.data;
              this.getMaintenanceModeList(Number(this.$route.params.id), { title: this.searchData }, this.pageData, this.limitData);
              this.hideProperties();
            }
          });
        }
      });
    },

    changeLevel(level) {
      if (!this.isDisabled) {
        this.dataMaintenance.level = level;
        this.dataMaintenance.pages_id = level === 'page' ? [] : null;
      }
    },

    handleSearch() {
      this.searchData = this.search;
      this.getMaintenanceModeList(Number(this.$route.params.id), { title: this.searchData }, this.pageData, this.limitData);
    },

    previousPage() {
      if (this.pageData > 1) {
        this.pageData = this.pageData - 1;
        this.getMaintenanceModeList(Number(this.$route.params.id), { title: this.searchData }, this.pageData, this.limitData);
      }
    },

    forwardPage() {
      if (this.maintenanceList.length === 20) {
        this.pageData = this.pageData + 1;
        this.getMaintenanceModeList(Number(this.$route.params.id), { title: this.searchData }, this.pageData, this.limitData);
      }
    },

    setValueStartPeriode(val) {
      if (val && this.dataMaintenance.end_period && (val > this.dataMaintenance.end_period)) {
        this.toggleProblem("Start period can't be more than end period");
        this.dataMaintenance.start_period = null;
      } else {
        this.dataMaintenance.start_period = val;
      }
    },

    setValueEndPeriode(val) {
      if (val && this.dataMaintenance.start_period && (val < this.dataMaintenance.start_period)) {
        this.toggleProblem("End period can't be less than start period");
        this.dataMaintenance.end_period = null;
      } else {
        this.dataMaintenance.end_period = val;
      }
    },

    getSubPageByParent(parentId) {
      return this.listPages.filter(page => page.parent_id === parentId)
        .sort((a, b) => a.order - b.order);
    },

    showModalOrganigram() {
      this.isShowModalOrganigram = true;
    },

    closeModalOrganigram() {
      this.isShowModalOrganigram = false;
      this.userOrganigram = null;
      setTimeout(() => { this.$v.userOrganigram.$reset(); }, 100);
    },

    submitOrganigram() {
      this.$v.userOrganigram.$touch();
      if (!this.$v.userOrganigram.$error) {
        this.dataUserOrganigram.push(this.userOrganigram);
        if (this.dataMaintenance.user_organigram_exception === null) {
          this.dataMaintenance.user_organigram_exception = [this.userOrganigram.id];
        } else {
          this.dataMaintenance.user_organigram_exception.push(this.userOrganigram.id);
        }
        this.closeModalOrganigram();
      }
    },

    removeOrganigram(index) {
      this.dataMaintenance.user_organigram_exception.splice(index, 1);
      this.dataUserOrganigram.splice(index, 1);
    },

    loadUserOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: 'id',
              ascending: true,
              query: searchQuery,
              query_type: 'position',
            },
          };
          jApiUser.listOrganigram(reqData).then((res) => {
            const mapRes = res.data.data;
            if (mapRes.length > 0) { callback(null, mapRes); }
            callback(null, false);
          });
        } else {
          callback(null, false);
        }
      }
    },

    getDateToday() {
      const todayDate = new Date();
      return String(this.$moment(todayDate).format('YYYY-MM-DDTHH:mm:ss'));
    },

    getDateStartPeriode() {
      return String(this.$moment(this.dataMaintenance.start_period).format('YYYY-MM-DDTHH:mm:ss'));
    },

    getDateEndPeriode() {
      return String(this.$moment(this.dataMaintenance.end_period).format('YYYY-MM-DDTHH:mm:ss'));
    },
  },
  validations() {
    return {
      dataMaintenance: {
        title: { required },
        start_period: { required },
        end_period: { required },
        level: { required },
        custom_message: {
          required: requiredIf(() => this.dataMaintenance.is_use_custom_message),
        },
        user_organigram_exception: {
          required: requiredIf(() => this.dataMaintenance.is_use_user_exception),
        },
      },
      userOrganigram: { required },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access/tab/jAccessApplicationTabMaintenance.vue